import Base from './base'
import urls from 'config/urls'

class Article extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.article.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.article.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.article.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.article.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.article.delete,
      data: opts
    })
  }

  findCategory (opts) {
    return this.httpGet({
      url: urls.article.findCategory,
      data: opts
    })
  }

  createCategory (opts) {
    return this.httpPost({
      url: urls.article.createCategory,
      data: opts
    })
  }

  updateCategory (opts) {
    return this.httpPost({
      url: urls.article.updateCategory,
      data: opts
    })
  }

  deleteCategory (opts) {
    return this.httpPost({
      url: urls.article.deleteCategory,
      data: opts
    })
  }

  setTopmost (opts) {
    return this.httpPost({
      url: urls.article.setTopmost,
      data: opts
    })
  }
}

export default new Article



// WEBPACK FOOTER //
// ./src/models/article.js